import React, { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Link, Checkbox } from '@heroui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const VersionUpdateModal = ({ isOpen, termsVersion, privacyVersion, onAccept }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAccept = async () => {
    if (!termsAccepted || !privacyAccepted) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onAccept(termsVersion, privacyVersion);
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const canSubmit = termsAccepted && privacyAccepted && !isSubmitting;

  return (
    <Modal
      isOpen={isOpen}
      isDismissable={false}
      hideCloseButton
      backdrop="blur"
      classNames={{
        backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20"
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <ExclamationTriangleIcon className="w-6 h-6 text-warning" />
            <span>Updated Terms & Privacy Policy</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <p className="text-foreground/80">
            We've updated our Terms of Service and Privacy Policy. Please review and accept the new versions to continue using ClipKite.
          </p>

          <div className="flex flex-col gap-3 mt-4">
            <Checkbox
              isSelected={termsAccepted}
              onValueChange={setTermsAccepted}
              size="sm"
            >
              <span className="text-sm">
                I have read and accept the{' '}
                <Link
                  href="/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  size="sm"
                >
                  Terms of Service (v{termsVersion})
                </Link>
              </span>
            </Checkbox>

            <Checkbox
              isSelected={privacyAccepted}
              onValueChange={setPrivacyAccepted}
              size="sm"
            >
              <span className="text-sm">
                I have read and accept the{' '}
                <Link
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  size="sm"
                >
                  Privacy Policy (v{privacyVersion})
                </Link>
              </span>
            </Checkbox>
          </div>

          <p className="text-xs text-foreground/60 mt-4">
            You must accept both documents to continue. If you don't accept, you will be signed out.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onPress={handleAccept}
            isDisabled={!canSubmit}
            isLoading={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Accepting...' : 'Accept & Continue'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default VersionUpdateModal;
